module.exports = __webpack_public_path__ + "img/object_remove_icon_1.0dec1e1c.webp";